// extracted by mini-css-extract-plugin
export default {"ingredients":"burger-ingredients_ingredients__s7nFm","tab":"burger-ingredients_tab__7Mpm0"};